import React, { useState } from 'react';
import MainContext from './MainContext';
import {
  signup,
  login,
  googleLogin,
  fetchAOwner,
  forgotpassowrd,
  getAllUsers,
  // updateOwnerSettings,
  updateOwnerProfile,
  updateOwnerProfileImage,
  updateShowServicePriceInWebsite,
  // updateOwnerSalesMask,
  updateOwnerCombinedMasking,
  OwnerVarification,
  sendDownloadBtnOtp,
  verifyDownloadBtnOtp,
  updateDownloadButtonVisibility,
} from './contextPages/AuthContexts';
import {
  fetchAllClients,
  getAllClient,
  fetchClientByNumber,
  fetchClientById,
  createClient,
  createManyClient,
  buyMembership,
  updateClient,
  sendBulkSms,
  deleteClient,
  fetchBillByClientNumber,
  fetchVisitedClinetAnalytics,
  getClientReviews,
  submitwalletPayment,
  getAllLossClient,
  fetchDayWiseReport,
  extendMembership,
  getExpiredMemberships,
  updateMembershipBill,
  updatePackageBill,
} from './contextPages/ClientContexts';
import {
  fetchAllProducts,
  createProduct,
  createManyProduct,
  updateProduct,
  deleteProduct,
  deleteManyProduct,
  addProductCount,
  getProductDetails
} from './contextPages/ProductContexts';
import {
  createConsumeProduct, 
  fetchAllConsumeProducts,
  fetchConsumeProductById,
  addConsumeableProductCount,
  updateConsumeableProduct,
  deleteConsumeableProduct,
  fetchServicesBillById,
  saveConsumedProducts,
  createManyConsumeableProduct
} from './contextPages/ConsumeableProductsContexts';
import {
  fetchAllMemberships,
  fetchMembershipDetail,
  createMembership,
  updateMembership,
  deleteMembership,
  createPackages,
  fetchAllPackages,
  fetchSinglePackageDetail,
  updatePackage,
  buyPackage,
  deletePackages,
  bulkUploadMembership
} from './contextPages/MembershipContexts';
import {
  fetchAllAppointments,
  fetchAppointmentById,
  fetchStaffAppointmentsDateWise,
  createAppointment,
  updateAppointment,
  updateAppointmentStatus,
  deleteAppointment,
  assignAppointment,
  createWebAppointmentBookingLink,
  fetchAppointmentAnalytics,
  getAppointmentPageData,
} from './contextPages/AppointmentContexts';
import {
  fetchAllStaffs,
  getAllStaff,
  createStaff,
  updateStaff,
  deleteStaff,
  getStaffById,
  fetchStaffOverviewData,
  fetchAttendanceByStaffId,
  staffCollection,
  changeStaffAccountStatus,
  staffStatusUpdate,
  fetchStaffWiseWork,
  staffWorkAnalysis,
  staffOverview,
  fetchSalarySlipById,
  fetchStaffAdvanceById,
  fetchStaffIncentiveById,
  setCalendarEntry,
  bulkSetCalendar,
  removeCalendarEntry,
  getStaffCalendar,
  getStaffCalendarView,
  getAllLeaveRequestsByBranch,
  updateLeaveStatus,
  fetchStaffLeaves,
} from './contextPages/StaffContexts';
import {
  fetchAllServices,
  getAllService,
  createService,
  updateService,
  deleteService,
  createManyService,
  deleteManyService,
  getServiceRemindersByBranch,
  updateServiceReminder,
  deleteServiceReminder,
} from './contextPages/ServiceContexts';
import {
  fetchAllBillings,
  fetchBillAnalytics,
  fetchBillById,
  createBilling,
  deleteBilling,
  updateBill,
  clearRemainingAmount,
  fetchPackageBills,
  // new
  deletePackagebill,
  getGstData,
  fetchDraftBill,
  createDraftBilling,
  fetchSingleBill,
  fetchPackageBillById,
  deleteDraftBill,
  fetchPackageAndMembershipBills,
  createManyBills,
  getWhatsAppTemplates,
  sendBulkWhatsApp,
  fetchSalesExpenseSummary
} from './contextPages/BillingContexts';
import {
  fetchAllBranch,
  fetchParentBranch,
  getBranch,
  createBranch,
  updateBranch,
  deleteBranch,
  getFeedbackUrl,
  getBillUrl,
  getBranchTimings,
  getBranchNotification
} from './contextPages/BranchContexts';
import { fetchAllFeedbacks, createFeedback } from './contextPages/FeedbackContexts';
import { fetchAllCategories, createCategory } from './contextPages/CategoryContext';
import { fetchAllSubscription } from './contextPages/SubscriptionsContexts';
import {
  fetchAllCoupon,
  createCoupon,
  updateCoupon,
  deleteCoupon,
} from './contextPages/CouponContexts';
import {
  fetchAllExpenses,
  fetchExpenseAnalytics,
  fetchAllExpenseType,
  createExpense,
  createManyExpense,
  updateExpense,
  deleteExpense,
} from './contextPages/ExpenseContexts';
import { fetchOverviewData } from './contextPages/DashboardContexts';
import { IvrCall, fetchIvr, updateIvrDetails } from './contextPages/IvrContexts';
import {
  fetchNotifications,
  fetchAccountExpiration,
  fetchRemainingMessages,
} from './contextPages/NotificationContexts';
import {
  fetchAllEquiry,
  createClientEnquiry,
  updateClientEnquiry,
  deleteClientEnquiry,
} from './contextPages/ClientEnquiryContexts';

import {
  monthwisesalesreport,
  monthwiseexpensereport,
  topperformer,
  staffperformance,
  topmembershippackages,
  topserviceproducts,
  getAvailableReportModels,
  exportReport,
  exportCombinedReport,
} from './contextPages/ReportContext';

import { updateMsg91Whatsapp, 
  updateMsg91Whatsapptemplatenames, 
  getWhatsappSettings,
resetWhatsappSettings } from './contextPages/SettingsContext';
import {getAllServiceCategories, serviceCreateCategory, serviceUpdateCategory} from './contextPages/serviceCategoryContext';
import {verifyGstin} from './contextPages/GstContext';
import {fetchAllWhatsappCampaigns , fetchWhatsappCampaignDetails} from './contextPages/WhatsappCampaignContexts' ;

const MainState = (props) => {
  const [activeBranchId, setActiveBranchId] = useState(null);
  const [ownerData, setOwnerData] = useState({});
  const [branchData, setBranchData] = useState({});
  const [showMessage, setShowMessage] = useState({});
  //console.log(branchData);
 
  return (
    <>
      <MainContext.Provider
        value={{
          activeBranchId,
          setActiveBranchId,

          setBranchData,
          branchData,

          IvrCall,
          fetchIvr,
          updateIvrDetails,

          ownerData,
          setOwnerData,

          showMessage,
          setShowMessage,

          fetchOverviewData,
          

          fetchAllBranch,
          fetchParentBranch,
          getBranch,
          createBranch,
          updateBranch,
          deleteBranch,
          getFeedbackUrl,
          getBillUrl,
          getBranchTimings,
          getBranchNotification,

          fetchAllCoupon,
          createCoupon,
          updateCoupon,
          deleteCoupon,

          fetchAllExpenses,
          fetchExpenseAnalytics,
          fetchAllExpenseType,
          createExpense,
          createManyExpense,
          updateExpense,
          deleteExpense,

          fetchAllStaffs,
          getAllStaff,
          getStaffById,
          fetchStaffOverviewData,
          staffCollection,
          fetchAttendanceByStaffId,
          createStaff,
          updateStaff,
          deleteStaff,
          changeStaffAccountStatus,
          staffStatusUpdate,
          fetchStaffWiseWork,
          staffWorkAnalysis,
          staffOverview,
          fetchSalarySlipById,
          fetchStaffAdvanceById,
          fetchStaffIncentiveById,
          setCalendarEntry,
          bulkSetCalendar,
          removeCalendarEntry,
          getStaffCalendar,
          getStaffCalendarView,
          getAllLeaveRequestsByBranch,
          updateLeaveStatus,
          fetchStaffLeaves,

          fetchAllAppointments,
          fetchAppointmentById,
          fetchStaffAppointmentsDateWise,
          createAppointment,
          updateAppointment,
          updateAppointmentStatus,
          deleteAppointment,
          assignAppointment,
          createWebAppointmentBookingLink,
          fetchAppointmentAnalytics,
          getAppointmentPageData,

          fetchAllClients,
          getAllClient,
          fetchClientByNumber,
          fetchClientById,
          createClient,
          createManyClient,
          buyMembership,
          updateClient,
          sendBulkSms,
          deleteClient,
          fetchBillByClientNumber,
          fetchVisitedClinetAnalytics,
          getClientReviews,
          submitwalletPayment,
          getAllLossClient,
          fetchDayWiseReport,
          extendMembership,
          getExpiredMemberships,
          updateMembershipBill,
          updatePackageBill,

          fetchMembershipDetail,
          fetchAllMemberships,
          createMembership,
          updateMembership,
          deleteMembership,
          createPackages,
          fetchAllPackages,
          fetchSinglePackageDetail,
          updatePackage,
          buyPackage,
          deletePackages,
          bulkUploadMembership,

          fetchAllProducts,
          createProduct,
          createManyProduct,
          updateProduct,
          deleteProduct,
          deleteManyProduct,
          addProductCount,
          getProductDetails,
          
          //new consumeable products
          createConsumeProduct,
          fetchAllConsumeProducts,
          fetchConsumeProductById,
          addConsumeableProductCount,
          updateConsumeableProduct,
          deleteConsumeableProduct,
          fetchServicesBillById,
          saveConsumedProducts,
          createManyConsumeableProduct,

          fetchAllServices,
          getAllService,
          createService,
          deleteService,
          createManyService,
          deleteManyService,
          updateService,
          getServiceRemindersByBranch,
          updateServiceReminder,
          deleteServiceReminder,

          fetchAllBillings,
          fetchBillAnalytics,
          fetchBillById,
          createBilling,
          deleteBilling,
          updateBill,
          clearRemainingAmount,
          fetchPackageBills,
          // new 
          deletePackagebill,
          getGstData,
          fetchDraftBill,
          createDraftBilling,
          fetchSingleBill,
          fetchPackageBillById,
          deleteDraftBill,
          fetchPackageAndMembershipBills,
          createManyBills,
          getWhatsAppTemplates,
          sendBulkWhatsApp,
          fetchSalesExpenseSummary,

          fetchAllFeedbacks,
          createFeedback,

          fetchAllCategories,
          createCategory,

          signup,
          login,
          googleLogin,
          fetchAOwner,
          // updateOwnerSettings,
          updateOwnerProfile,
          updateOwnerProfileImage,
          updateShowServicePriceInWebsite,
          getAllUsers,
          forgotpassowrd,
          // updateOwnerSalesMask,
          OwnerVarification,
          updateOwnerCombinedMasking,
          sendDownloadBtnOtp,
          verifyDownloadBtnOtp,
          updateDownloadButtonVisibility,


          fetchAllSubscription,

          fetchNotifications,
          fetchAccountExpiration,
          fetchRemainingMessages,

          fetchAllEquiry,
          createClientEnquiry,
          updateClientEnquiry,
          deleteClientEnquiry,

          monthwisesalesreport,
          monthwiseexpensereport,
          topperformer,
          staffperformance,
          topmembershippackages,
          topserviceproducts,
          exportReport,
          getAvailableReportModels,
          exportCombinedReport,

          updateMsg91Whatsapp,
          updateMsg91Whatsapptemplatenames,
          getWhatsappSettings,
          resetWhatsappSettings,

          serviceUpdateCategory,
          serviceCreateCategory,
          getAllServiceCategories,

          verifyGstin,

          fetchAllWhatsappCampaigns,
          fetchWhatsappCampaignDetails,
        
        }}
      >
        {props.children}
      </MainContext.Provider>
    </>
  );
};

export default MainState;
